import React, { useEffect, useState } from 'react';
import './LendingSupport.scss';
import { DeskingOffer } from '@upstart/harmony/lib/legos/deskingTypes';
import DeskingService from '../../services/DeskingService';
import { JsonLinks } from './JsonLinks';

const RequiredPencilVersion = '2';

interface Props {
  carId?: string;
  dealId?: string;
  onClick: (deskingOffer?: object) => void;
  onError: (message: string) => void;
  pencilVersion?: string;
}

export const LendingSupportDeskingOffers: React.FC<Props> = ({
  carId,
  dealId,
  pencilVersion,
  onClick,
  onError,
}) => {
  const [deskingOffers, setDeskingOffers] = useState<
    DeskingOffer[] | null | undefined
  >();

  useEffect(() => {
    setDeskingOffers(undefined);
    if (!carId || !dealId || pencilVersion !== RequiredPencilVersion) {
      setDeskingOffers(null);
      return;
    }
    DeskingService.getDesking(dealId, carId)
      .then((deskigResults: { desking: { deskingOffers: DeskingOffer[] } }) => {
        setDeskingOffers(deskigResults.desking.deskingOffers);
      })
      .catch(() => {
        setDeskingOffers(null);
        onError('Unable to fetch desking offers');
      });
  }, [carId, dealId, pencilVersion]);

  return (
    <>
      <div>Desking Offers:</div>
      <div className="lending-support-pencils-container">
        <JsonLinks
          dataList={deskingOffers}
          getName={(deskingOffer, index) =>
            `${(deskingOffer as DeskingOffer).data?.financeType}`
          }
          getKey={(deskingOffer, index) =>
            `${
              (deskingOffer as DeskingOffer).data?.financeType
            }${(deskingOffers?.length ?? 0) - index}`
          }
          onClick={onClick}
        />
      </div>
    </>
  );
};
